import React from 'react'
import {Nav} from 'reactstrap'

const nav=(props)=>(<Nav {...props}/>)

export default nav;